import { Grid, Typography } from '@mui/material'
import React from 'react'
import { ControlledTextField } from '../ControlledTextField'
import { FieldContainer } from '../FieldContainer'
import { BankSelect } from './BankSelect'

export const AccountDetails = () => {
  return (
    <FieldContainer>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <BankSelect />
        </Grid>
        <Grid item xs={12} md={6}>
          <ControlledTextField
            name='bankAccountName'
            label='Bank Account Name'
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <ControlledTextField
            name='bankAccountNumber'
            label='Bank Account Number'
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <ControlledTextField name='tin' label='TIN' />
        </Grid>
        <Grid item xs={12}>
          <Typography variant='caption'>
            Details will be kept <strong>STRICTLY CONFIDENTIAL</strong> and will
            only be used for payment disbursement.
          </Typography>
        </Grid>
      </Grid>
    </FieldContainer>
  )
}
